import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";
import SuccessStory from "../home/_components/successStory";
import CourseList from "./_components/CourseList";
import Hero from "./_components/hero";

export default function Courses() {
  return (
    <WebLayout>
      <Hero />
      {/* <SomeCources /> */}
      <CourseList />
      <SuccessStory />
      <Platform />
      <Footer isPlatform={true} />
    </WebLayout>
  );
}
